import { render, staticRenderFns } from "./ShipmentSearch.vue?vue&type=template&id=02455e73&scoped=true"
import script from "./ShipmentSearch.vue?vue&type=script&lang=js"
export * from "./ShipmentSearch.vue?vue&type=script&lang=js"
import style0 from "./ShipmentSearch.vue?vue&type=style&index=0&id=02455e73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02455e73",
  null
  
)

export default component.exports